function configUrl() {
  const config: Props = {
    API_URL: '',
    ENVIRONMENT: '',
    GRAPHQL_URL: '',
    OTLP: {
      trace: '',
    },
    TEMPLATE_API_KEY: '',
  }
  const envVariable: any = process.env
  config.API_URL = envVariable.REACT_APP_API_URL
  config.OTLP.trace = envVariable.REACT_APP_TRACE_URL
  config.ENVIRONMENT = envVariable.NODE_ENV
  config.TEMPLATE_API_KEY = envVariable.REACT_APP_TEMPLATE_API_KEY
  config.GRAPHQL_URL = envVariable.REACT_APP_GRAPHQL_API

  return config
}

type Otlp = {
  trace: string
}

type Props = {
  API_URL: string
  ENVIRONMENT: string
  OTLP: Otlp
  TEMPLATE_API_KEY: string
  GRAPHQL_URL: string
}

const config: Props = configUrl()
;(window as any).TEMPLATE_API_KEY = config.TEMPLATE_API_KEY

export default config
